module.exports = __webpack_public_path__ + "img/workflow.0a77b0bb.png";